export function isCoreSubject(subject) {
  return subject === 'Reading' || subject === 'Writing' || subject === 'Math'
}
